module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGd6b436eef2b483e3247bf93be1e553d1.d6b436ee.png";